import _Vue from 'vue'
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import { ApiResponse, HttpAxiosResponse, HttpAxiosError } from '@/models/apiResponses/httpModel'
import VueCookies from 'vue-cookies'
import _router from 'vue-router'

interface RouterInterface {
  push(path: string): void
}

export default {
  install(Vue: typeof _Vue, router: typeof _router): void {
    // ログインや認証不要な場合のAPI
    const http: AxiosInstance = this.initAxios()
    // 認証情報付きのAPI
    const httpWithToken: AxiosInstance = this.initAxios()

    httpWithToken.interceptors.request.use((request: AxiosRequestConfig) => {
      // 認証情報の取得
      const auth = (VueCookies as any).get('authBcbt')
      if (auth && auth.accessToken != request.headers['access-token']) {
        request.headers['access-token'] = auth.accessToken
        request.headers.client = auth.client
        request.headers.uid = auth.uid
      }
      return request
    })

    // 認証後のWeb APIでリダイレクトや共通して処理したい場合はこちらに記述を追加
    httpWithToken.interceptors.response.use(
      (reponse: HttpAxiosResponse) => reponse,
      async (error: Error | HttpAxiosError) => {
        if (axios.isAxiosError(error)) {
          if (!error.response) {
            alert('接続障害が発生しております。しばらくしてから画面を再読み込みしてください。')
          } else {
            // router.push等によりローディング処理が残っているケースがあるため、画面遷移時は終了処理を実行
            Vue.prototype.$loading.complete()

            // responseTypeがblobの時にerror.response.dataをjsonに書き換える
            await this.onBlobHandler(error).catch(() => {
              ;(router as unknown as RouterInterface).push('/error/error500')
            })

            if (error.response.status === 401) {
              ;(router as unknown as RouterInterface).push('/error/error401')
            } else if (error.response.status === 404 && (error.response.data as ApiResponse).code !== 40401) {
              ;(router as unknown as RouterInterface).push('/error/error404')
            } else if (error.response.status === 500) {
              ;(router as unknown as RouterInterface).push('/error/error500')
            }
          }
        } else {
          Vue.prototype.$logger.log('httpWithToken(Error)', error)
        }
        return Promise.reject(error)
      }
    )

    Vue.prototype.$http = { http, httpWithToken }
  },

  async onBlobHandler(error: HttpAxiosError): Promise<void> {
    if (error.request.responseType === 'blob' && error.response && error.response.data instanceof Blob) {
      const text = await new Promise((resolve, reject) => {
        const fileReader = new FileReader()

        fileReader.onerror = () => {
          fileReader.abort()
          reject()
        }
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
        if (error.response && error.response.data instanceof Blob) fileReader.readAsText(error.response.data)
      })
      // @ts-ignore
      error.response.data = JSON.parse(text)
    }
  },

  initAxios(): AxiosInstance {
    return axios.create({
      baseURL: process.env.VUE_APP_WEB_API_URL,
      timeout: 180000,
      headers: {
        'Content-Type': 'application/json',
        'X-Language': 'ja',
      },
    })
  },
}

// ? 各画面で言語を変更する場合はAPI前に下記のように設定
// ? Vue.prototype.$http.http.defaults.headers['X-Language'] = 'en'
